/*
 * main.js
 *
 * Description: main.js
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019.2020  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import VueRouter from 'vue-router'; // v0.3
import SundAir2019Plugin from './plugins/sundair2019-plugin.js';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import Toasted from 'vue-toasted';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VTooltip from 'v-tooltip';
import VModal from 'vue-js-modal';
import ToggleButton from 'vue-js-toggle-button';
import PrettyCheckbox from 'pretty-checkbox-vue'; // Note: css gets loaded in Header
import Vuelidate from 'vuelidate';
import VueSwal from 'vue-swal';
import Storage from 'vue-ls';
import VuePikaday from '@enrian/vue-pikaday';
import '@enrian/vue-pikaday/dist/vue-pikaday.min.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';


// >>> Module:Shared -----------------------------------------------------------
import FlightSearchTab from './components/shared/flightsearch/FlightSearchTab.vue';
import FlightSearchResults from './components/shared/flightsearch/FlightSearchResults.vue';
import BookingnoOverview from './components/services/pagecontent/BookingnoOverview.vue';

import SeatTab from './components/shared/forms/SeatTab.vue';
import LuggageTab from './components/shared/forms/LuggageTab.vue';
import HelpTab from './components/shared/forms/HelpTab.vue';
import Cart from './components/shared/cart/Cart.vue';
import FooterFirstRow from './components/shared/footer/FirstRow.vue'; // Footer 1st Row
import FooterSecondRow from './components/shared/footer/SecondRow.vue'; // Footer 2nd Row
import FooterThirdRow from './components/shared/footer/ThirdRow.vue'; // Footer 3rd Row
import LanguageList from './components/shared/header/LanguageList.vue'; // Header Language
import NavbarMain from './components/shared/header/NavbarMain.vue'; // Header Navbar Main
import SundairLogin from './components/shared/header/SundairLogin.vue'; // Sundair Login
import NavbarBreadcrumbs from './components/shared/header/NavbarBreadcrumbs.vue'; // Header Navbar BreadCrumbs

// >>> Global Store ------------------------------------------------------------ 'Stores'
import { store } from './store/store';

// >>> Global Filters ---------------------------------------------------------- 'Filters'
import './filters/filters';

// >>> Global Routes ----------------------------------------------------------- 'Routes - Booking'
import { routesbooking } from './routes/modules/booking/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Services'
import { routesservices } from './routes/modules/services/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Rebooking'
import { routesrebooking } from './routes/modules/rebooking/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Career'
import { routescareer } from './routes/modules/career/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Flightplan'
import { routesflightplan } from './routes/modules/flightplan/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Infos'
import { routesinfos } from './routes/modules/infos/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Pressreleases'
import { routespressreleases } from './routes/modules/pressreleases/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Checkout'
import { routescheckout } from './routes/modules/checkout/routes';



// >>> Global Axios - Configs -------------------------------------------------- 'Axios - Config'
axios.defaults.baseURL = '/rest';
axios.defaults.headers = {
    Accept: 'application/json',
    langCode: 'DE',
    apiKey: '1a28cdcd124e01d13d77616110a33ad9', // , buc key '1a28cdcd124e01d13d77616110a33ad9'
    Authorization: null,
};
axios.interceptors.request.use(config => {
    var lang = 'DE',
        user = '',
        pass = '',
        localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')), // catch
        localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username')), // catch
        localStorageAgencyPass = JSON.parse(localStorage.getItem('sdr__agency_password')); // catch


    // >>> Language in localStorage? ------------
    if (localStorageLanguage !== null) {
        lang = localStorageLanguage.value.toUpperCase();
    }
    config.headers.langCode = lang;

    // >>> Agency in localStorage? --------------
    if (localStorageAgencyUser !== null) {
        user = localStorageAgencyUser.value;
        pass = localStorageAgencyPass.value;
        config.headers.username = user;
        config.headers.password = pass;
    }

    // before a request is made start the nprogress
    // NProgress.start();

    return config;
});
axios.interceptors.response.use(response => {
    // before a response is returned stop nprogress
    // NProgress.done();
    return response;
});




// >>> VueRouter --------------------------------------------------------------- 'VueRouter - Config'
Vue.use(VueRouter);
const routerBooking = new VueRouter({
    //mode: 'history',
    routes: routesbooking
});
const routerServices = new VueRouter({
    //mode: 'history',
    routes: routesservices
});
const routerRebooking = new VueRouter({
    //mode: 'history',
    routes: routesrebooking
});
const routerCareer = new VueRouter({
    //mode: 'history',
    routes: routescareer
});
const routerFlightplan = new VueRouter({
    //mode: 'history',
    routes: routesflightplan
});
const routerInfos = new VueRouter({
    //mode: 'history',
    routes: routesinfos
});
const routerPressreleases = new VueRouter({
    //mode: 'history',
    routes: routespressreleases
});
const routerCheckout = new VueRouter({
    //mode: 'history',
    routes: routescheckout
});



// >>> Global Plugin -----------------------------------------------------------
Vue.use(SundAir2019Plugin);


// >>> Global ScrollTo ---------------------------------------------------------
Vue.use(VueScrollTo);


// >>> Global Toast ------------------------------------------------------------
Vue.use(Toasted);
let toastOptionsError = {
    type: 'error',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'top-center',
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 5000
};
Vue.toasted.register('sdr_app_error', (payload) => {

        // if there is no message passed show default message
        if (!payload.message) {
            return "Oops.. Something Went Wrong..";
        }

        // if there is a message show it with the message
        return "Oops.. " + payload.message;
    }, toastOptionsError);

let toastOptionsInfo = {
    type: 'info',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'top-center',
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 5000
};
Vue.toasted.register('sdr_app_info', (payload) => {

        // if there is no message passed show default message
        if (!payload.message) {
            return 'Oops.. Something Went Wrong..';
        }

        // if there is a message show it with the message
        return 'Worked.. ' + payload.message;

}, toastOptionsInfo);


// >>> Init Plugin - Loading ---------------------------------------------------
Vue.use(Loading);


// >>> Init Plugin - VTooltip  -------------------------------------------------
Vue.use(VTooltip);


// >>> Init Plugin - VModal  ---------------------------------------------------
Vue.use(VModal, { dialog: true });


// >>> Init Plugin - ToggleButton  ---------------------------------------------
Vue.use(ToggleButton);


// >>> Init Plugin - PrettyCheckbox  -------------------------------------------
Vue.use(PrettyCheckbox);


// >>> Init Plugin - Vuelidate -------------------------------------------------
Vue.use(Vuelidate);


// >>> Init Plugin - VueSwal ---------------------------------------------------
Vue.use(VueSwal);


// >>> Init Plugin - Storage ---------------------------------------------------
let storageOptions = {
    namespace: 'sdr__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
};
Vue.use(Storage, storageOptions);

// >>> Init Plugin - PikaDay ---------------------------------------------------
Vue.use(VuePikaday);

// >>> Init Plugin - vSelect ---------------------------------------------------
Vue.component('v-select', vSelect)


// >>> -------------------------------------------------------------------------
export const eventBus = new Vue();




// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// >>> Vue Instance:'Booking' -------------------------------------------------- 'Booking'
var vm_booking = new Vue({

    components: {
        'sdr-shared-flightsearch-tab': FlightSearchTab,
        'sdr-shared-seat-tab': SeatTab,
        'sdr-shared-luggage-tab': LuggageTab,
        'sdr-shared-help-tab': HelpTab,
        // --------------------------------------
        'sdr-shared-flightsearchresults': FlightSearchResults,
        // --------------------------------------
        'sdr-shared-cart': Cart,
        // --------------------------------------
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerBooking, // global 'Booking' one


    /***************************************************************************
    * Instant LifeCycle(s)
    *
    * Desc: Build Authorization Header. Language too.
    * Note: See Plugin.
    *
    */
    created: function () {

        axios.defaults.headers.Authorization = this.$make_basic_auth();
        axios.defaults.headers.langCode = this.$header_language();

    } // eof created()

});
vm_booking.$mount('.ModuleBooking');



// >>> Vue Instance:'Service' -------------------------------------------------- 'Service'
var vm_services = new Vue({

    components: {
        'sdr-shared-flightsearch-tab': FlightSearchTab,
        'sdr-shared-help-tab': HelpTab,
        // --------------------------------------
        'sdr-shared-flightsearchresults': FlightSearchResults,
        'sdr-services-bookingnooverview': BookingnoOverview,
        // --------------------------------------
        'sdr-shared-cart': Cart,
        // --------------------------------------
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerServices, // global 'Services' one

});
vm_services.$mount('.ModuleServices');



// >>> Vue Instance:'Rebooking' ------------------------------------------------ 'Rebooking'
var vm_rebooking = new Vue({

    components: {
        // --------------------------------------
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerRebooking, // global 'Booking' one


    /***************************************************************************
    * Instant LifeCycle(s)
    *
    * Desc: Build Authorization Header. Language too.
    * Note: See Plugin.
    *
    */
    created: function () {

        axios.defaults.headers.Authorization = this.$make_basic_auth();
        axios.defaults.headers.langCode = this.$header_language();

    } // eof created()

});
vm_rebooking.$mount('.ModuleRebooking');



// >>> Vue Instance:'Career' --------------------------------------------------- 'Career'
var vm_career = new Vue({

    components: {
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerCareer, // global 'Career' one

});
vm_career.$mount('.ModuleCareer');



// >>> Vue Instance:'Flightplan' -----------------------------------------------'Flightplan'
var vm_flightplan = new Vue({

    components: {
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerFlightplan, // global 'Career' one

});
vm_flightplan.$mount('.ModuleFlightplan');



// >>> Vue Instance:'Pressreleases' -------------------------------------------- 'Pressreleases'
var vm_pressreleases = new Vue({

    components: {
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerPressreleases, // global 'Career' one

});
vm_pressreleases.$mount('.ModulePressreleases');



// >>> Vue Instance:'Checkout' ------------------------------------------------- 'Checkout'
var vm_checkout = new Vue({

    components: {
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerCheckout, // global 'Flightstatus' one

});
vm_checkout.$mount('.ModuleCheckout');



// >>> Vue Instance:'Shared' --------------------------------------------------- 'Shared - Infos'
var vm_shared = new Vue({

    components: {
        // --------------------------------------
        'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
        'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
        'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
        'sdr-shared-languagelist': LanguageList, // Header Language
        'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
        'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
        'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
    },
    store: store, // global one
    router: routerInfos, // global 'Infos' one

});
vm_shared.$mount('.ModuleShared');


// WEBPACK FOOTER //
// ./src/main.js